// 注册中心名称
const apiName = process.env.BUILD_ENV === "dev" ? "ec-pc-api" : "ec-pc-api";
// 竞店API
const product = {
  // 竞店店铺分页数据
  competeStoreMainData: {
    type: "post",
    url: `${apiName}/competeStore/competeStoreMainData`
  },
  // 适用情况下拉列表数据
  suitScopeSelect: {
    type: "get",
    url: `${apiName}/competeStore/suitScopeSelect`
  },

  // 竞店店铺分页数据
  competeStoreEdit: {
    type: "post",
    url: `${apiName}/competeStore/competeStoreEdit`
  },

  // 竞店店铺启用禁用
  updateState: {
    type: "get",
    url: `${apiName}/competeStore/updateState`
  },

  // 行业启用禁用
  updateCategoryState: {
    type: "post",
    url: `${apiName}/competeStore/updateCategoryState`
  },

  // 流量启用禁用
  updateFlowState: {
    type: "post",
    url: `${apiName}/competeStore/updateFlowState`
  },

  // 行业类目分页数据
  industryCategoryMainData: {
    type: "post",
    url: `${apiName}/competeStore/industryCategoryMainData`
  },


  // 二级类目下拉列表数据
  categorySelect: {
    type: "get",
    url: `${apiName}/competeStore/categorySelect`
  },

  // 行业类目 增加编辑
  industryCategoryEdit: {
    type: "post",
    url: `${apiName}/competeStore/industryCategoryEdit`
  },

  // 流量来源分页数据
  flowSourceMainData: {
    type: "post",
    url: `${apiName}/competeStore/flowSourceMainData`
  },

  // 一级流量下拉
  flowSelect: {
    type: "get",
    url: `${apiName}/competeStore/flowSelect`
  },

  // 流量来源 增加编辑
  flowEdit: {
    type: "post",
    url: `${apiName}/competeStore/flowEdit`
  },

  // 流量来源 查询
  storeSelect: {
    type: "get",
    url: `${apiName}/competeStore/storeSelect`
  },

  // 竞店对比 对比店铺统计
  comparisonData: {
    type: "post",
    url: `${apiName}/competeStore/comparison/comparisonData`
  },

  // 竞店流失 对比店铺统计
  comparisonDataLeave: {
    type: "post",
    url: `${apiName}/competeStore/comparison/comparisonDataLeave`
  },

  // 行业二/三级行业对比

  compare: {
    type: "post",
    url: `${apiName}/competeStore/industry/compare`
  },

  // 行业二/三级同期对比
  period: {
    type: "post",
    url: `${apiName}/competeStore/industry/period`
  },

  // 竞店推广对比店铺/对比同期统计
  contrastStoreData: {
    type: "post",
    url: `${apiName}/competeStore/spread/contrastStoreData`
  },



};

export default product;
